import { useCallback } from 'react';
import { offset, useFloating } from '@floating-ui/react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useZIndexMiddleware } from '../presentation/popper-modifiers';
import { useLinkModalContext, useLinkPopperContext } from './Context';
import { FloatingWrapper } from './FloatingWrapper';
import { useLinkPositioner, useRemoveLink } from './hooks';
import { LinkExtensionPopper } from './Link.Popper';

export const LinkPopperContainer = (props: ChildrenProps) => {

  const {
    open: openModal,
  } = useLinkModalContext();
  const {
    selection: popperSelection,
    close: closePopper,
  } = useLinkPopperContext();

  const handleRemove = useRemoveLink();

  const position = useLinkPositioner();
  const zIndexMiddleware = useZIndexMiddleware();
  const { floatingStyles, refs } = useFloating({
    elements: {
      reference: position.element,
    },
    middleware: [
      offset(5),
      zIndexMiddleware,
    ],
    placement: 'bottom-start',
  });

  const handleCancel = useCallback(() => {
    closePopper();
  }, [closePopper]);

  const handleEdit = useCallback(() => {
    openModal(popperSelection);
    closePopper();
  }, [closePopper, openModal, popperSelection]);

  return (
    <>
      <FloatingWrapper
        renderOutsideEditor={true}
        position={position}>
        <div
          ref={refs.setFloating}
          style={floatingStyles}>
          {position.active &&
            <ClickAwayListener onClickAway={closePopper}>
              <LinkExtensionPopper
                key={popperSelection?.text}
                href={popperSelection?.href}
                text={popperSelection?.text}
                onCancel={handleCancel}
                onClickEdit={handleEdit}
                onRemove={handleRemove} />
            </ClickAwayListener>
          }
        </div>
      </FloatingWrapper>
      {props.children}
    </>
  );
};